import { Card } from "ui";
import {
  DropdownSearchFormField,
  FormErrorMessage,
  FormField,
  FormLabel,
  InputFormField,
  SelectFormField,
} from "../../../features/form";
import { getAccountsWithSearch } from "../../../utils/dropdownsGetOptions";
import { Flow } from "../types";

const flowTypeOptions: [string, string][] = [
  ["pay_in", "Pay-In"],
  ["pay_out", "Pay-Out"],
];

type ConfigurationStepProps = {
  flow: Flow;
};

export const ConfigurationStep = ({ flow }: ConfigurationStepProps) => {
  return (
    <Card
      disableHover
      className="border-foundations-subtle bg-foundations-subtelst-02 p-4"
    >
      <h4 className="mb-4 text-xs font-medium uppercase text-foundations-bold">
        Configuration
      </h4>

      <div className="space-y-6">
        <FormField
          label="Flow name"
          name="name"
          required
          validation="required"
          defaultValue={`Copy of "${flow.name}"`}
        >
          <FormLabel />
          <InputFormField placeholder="Flow name" />
          <FormErrorMessage />
        </FormField>

        <FormField
          label="Flow type"
          name="flow_type"
          disabled
          defaultValue="pay_in"
          required
        >
          <FormLabel />
          <SelectFormField options={flowTypeOptions} />
          <FormErrorMessage />
        </FormField>

        <FormField
          label="Assigned account"
          name="account"
          required
          validation="required"
        >
          <FormLabel />
          <DropdownSearchFormField<string>
            getOptions={(searchTerm) =>
              getAccountsWithSearch(searchTerm).then(
                (res) =>
                  res.data.data.map(({ columns }) => [
                    columns.id,
                    columns.name,
                  ]) || []
              )
            }
            label="Select account"
            placeholder="Search accounts..."
            contentProps={{ className: "z-50" }}
          />
          <FormErrorMessage />
        </FormField>
      </div>
    </Card>
  );
};
